<template>
  <div class="grid">
    <loading
      :active="isLoadingModel"
      :can-cancel="true"
      color="#274461"
      :is-full-page="fullPage"
    ></loading>
    <Toast />
    <div class="col-12 sticky">
      <div id="custom_card" class="card">
        <div class="grid justify-content-between">
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-center md:justify-content-start md:mb-0 mb-3"
            >
              <p style="color: #3f51b5; font-size: 20px; font-weight: 800">
                {{ $t("job_openings") }}
              </p>
            </div>
          </div>
          <div class="col-12 md:col-6">
            <div
              class="flex flex-wrap align-items-center justify-content-end md:justify-content-end md:mb-0 mb-3"
            >
              <Button
                iconPos="right"
                :label="$t('add')"
                v-tooltip.bottom="$t('add')"
                icon="pi pi-plus"
                @click="openNew"
                size="small"
                style=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12">
      <div class="card" id="custom_card">
        <div class="grid p-fluid">
          <div class="col-12 md:col-12">
            <div class="p-fluid formgrid grid">
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <InputText
                    format="text"
                    v-model="search_filter"
                    @input="search(1)"
                  >
                  </InputText>
                  <label>{{ $t("search_type") }}</label>
                </span>
              </div>
              <div class="field col-12 md:col-2">
                <span class="p-float-label">
                  <Dropdown
                    id="status"
                    v-model="status_dropdownItem"
                    :options="status_dropdownItems"
                    optionLabel="name"
                    filter
                    @change="search(1)"
                  >
                  </Dropdown>
                  <label for="status">{{ $t("status") }}</label>
                </span>
              </div>
              <div class="field col-2 md:col-2">
                <Button
                  icon="pi pi-refresh"
                  v-tooltip.bottom="$t('refresh')"
                  @click="search(2)"
                  class="p-button-danger"
                  style=""
                />
              </div>
            </div>
          </div>
        </div>
        <DataTable
          :loading="loading"
          ref="dt"
          :lazy="true"
          :totalRecords="totalRecords"
          :paginator="true"
          :value="products"
          v-model:selection="selectedProducts"
          :dataKey="columns[0]"
          :rows="limit"
          :filters="filters"
          @page="onPage($event)"
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          :rowsPerPageOptions="PerPageOptions"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          responsiveLayout="scroll"
          style="font-size: 12px"
          :rowHover="true"
          showGridlines
        >
          <template #empty>
            <b style="text-align: center">{{ $t("no_rec") }}</b>
          </template>
          <template #header>
            <div style="text-align: right; font-weight: bold">
              <span>{{ $t("total_jobs") }}:</span>{{ totalRecords }}
            </div>
          </template>
          <Column
            :header="$t('status')"
            style="min-width: 8rem; text-align: center"
            :field="columns[5]"
          >
            <template #body="{ data }">
              <span v-if="data.status == 'Active' || data.status == 'active'"
                ><badge
                  class="p-button-success"
                  value="Active"
                  severity="success"
                ></badge
              ></span>
              <span v-else-if="data.status == 'In Active' || data.status == 'Inactive'"
                ><badge
                  class="p-button-warning"
                  value="In Active"
                  severity="warning"
                ></badge
              ></span>
              <span v-else-if="data.status == 'Deleted' || data.status == 'Deleted'"
                ><badge
                  class="p-button-danger"
                  value="Deleted"
                  severity="danger"
                ></badge
              ></span>
              <span v-else>-</span>
            </template>
          </Column>
          <Column :header="$t('job_title')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.job_title }}
            </template>
          </Column>
          <Column :header="$t('job_description')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.job_description }}
            </template>
          </Column>
          <Column :header="$t('experience_required')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.experience_required }}
            </template>
          </Column>
          <Column :header="$t('last_date_to_apply')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ dateFormatDMY(data.last_date_to_apply) }}
            </template>
          </Column>
          <Column :header="$t('location')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.location }}
            </template>
          </Column>
          <Column :header="$t('qualification')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.qualification }}
            </template>
          </Column>
           <Column :header="$t('vacancies')" style="min-width: 5rem">
            <template #body="{ data }">
              {{ data.vacancies }}
            </template>
          </Column>
          <Column :header="$t('action')" headerStyle="min-width:10rem;">
            <template #body="slotProps">
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-pencil"
                title="$t('edit_client')"
                v-tooltip.bottom="$t('edit')"
                class="p-button-rounded p-button-success mr-2"
                @click="editProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.status == 'Active'"
                icon="pi pi-eye"
                :title="$t('view_jobs')"
                v-tooltip.bottom="$t('view')"
                class="p-button-rounded p-button-warning mr-2"
                @click="viewProduct(slotProps.data)"
                style=""
              />
              <Button
                v-if="slotProps.data.status != 'Deleted'"
                icon="pi pi-trash"
                v-tooltip.bottom="$t('delete')"
                class="p-button-rounded p-button-danger mt-2"
                @click="confirmDeleteProduct(slotProps.data)"
                style=""
              />
            </template>
          </Column>
        </DataTable>
      </div>
    </div>
    <Dialog
      v-model:visible="productDialog"
      :breakpoints="{ '960px': '75vw' }"
      :style="{ width: '75vw' }"
      :header="$t('job_openings')"
      :modal="true"
      position="top"
    >
      <div class="col-12">
        <div class="p-fluid formgrid grid">
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Dropdown
                id="status"
                v-model="addeditstatus_dropdownItem"
                :options="status_dropdownItems"
                optionLabel="name"
                filter
                :disabled="!product._id"
              >
              </Dropdown>
              <label for="status">{{ $t("status") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="job_title"
                type="text"
                v-model="product.job_title"
              />
              <label for="name">{{ $t("job_title") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="job_title_mr"
                type="text"
                v-model="product.job_title_mr"
              />
              <label for="name">{{ $t("job_title_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="job_title_hi"
                type="text"
                v-model="product.job_title_hi"
              />
              <label for="name">{{ $t("job_title_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="experience_required"
                type="text"
                v-model="product.experience_required"
              />
              <label for="name">{{ $t("experience_required") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea
                id="job_description"
                type="text"
                v-model="product.job_description"
              />
              <label for="name">{{ $t("job_description") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea
                id="job_description_mr"
                type="text"
                v-model="product.job_description_mr"
              />
              <label for="name">{{ $t("job_description_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Textarea
                id="job_description_hi"
                type="text"
                v-model="product.job_description_hi"
              />
              <label for="name">{{ $t("job_description_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="vacancies"
                type="text"
                v-model="product.vacancies"
              />
              <label for="name">{{ $t("vacancies") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="qualification"
                type="text"
                v-model="product.qualification"
              />
              <label for="name">{{ $t("qualification") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="qualification_mr"
                type="text"
                v-model="product.qualification_mr"
              />
              <label for="name">{{ $t("qualification_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="qualification_hi"
                type="text"
                v-model="product.qualification_hi"
              />
              <label for="name">{{ $t("qualification_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Calendar
                id="ticket_title"
                v-model="product.posted_date"
                dateFormat="dd/mm/yy"
              />
              <label for="name">{{ $t("posted_date") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="location"
                type="text"
                v-model="product.location"
              />
              <label for="name">{{ $t("location") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="location_mr"
                type="text"
                v-model="product.location_mr"
              />
              <label for="name">{{ $t("location_mr") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <InputText
                id="location_hi"
                type="text"
                v-model="product.location_hi"
              />
              <label for="name">{{ $t("location_hi") }}</label>
            </span>
          </div>
          <div class="field col-12 md:col-3" style="margin-top: 2%">
            <span class="p-float-label">
              <Calendar
                id="ticket_title"
                v-model="product.last_date_to_apply"
                dateFormat="dd/mm/yy"
              />
              <label for="name">{{ $t("last_date_to_apply") }}</label>
            </span>
          </div>
        </div>
      </div>
      <template #footer>
        <Button
          :label="$t('save')"
          @click="save_event"
          icon="pi pi-check"
          class="p-button-success"
        />
      </template>
    </Dialog>
    <Dialog
      v-model:visible="deleteProductDialog"
      :style="{ width: '450px' }"
      :header="$t('Confirm')"
      :modal="true"
    >
      <div class="flex align-items-center justify-content-center">
        <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem" />
        <span v-if="product"
          >{{ $t("delete_msg") }}<b>{{ product.job_title }}</b
          >?</span
        >
      </div>
      <template #footer>
        <Button
          :label="$t('no')"
          icon="pi pi-times"
          class="p-button-text"
          @click="deleteProductDialog = false"
        />
        <Button
          :label="$t('yes')"
          icon="pi pi-check"
          class="p-button-text"
          @click="deleteevent"
        />
      </template>
    </Dialog>
  </div>
</template>
  <script>
import { FilterMatchMode } from "primevue/api";
import ProductService from "../service/ProductService";
import apis from "@/apis";
import axios from "axios";
export default {
  data() {
    return {
      status_dropdownItems: [
        { name: "Active", value: "Active" },
        { name: "In Active", value: "In Active" },
        { name: "Deleted", value: "Deleted" },
      ],
      status_dropdownItem: null,
      addeditstatus_dropdownItem: null,
      search_filter: "",
      user_key: "",
      page_no: 1,
      isLoading: false,
      PerPageOptions: [10, 50, 100],
      isLoadingModel: false,
      loading: false,
      fullPage: true,
      products: null,
      productDialog: false,
      deleteProductDialog: false,
      deleteProductsDialog: false,
      lazyParams: {},
      product: {},
      selectedProducts: null,
      filters: {},
      offset: 1,
      limit: 10,
      columns: [],
      pageno: 1,
      submitted: false,
      totalRecords: 0,
      id: "",
    };
  },
  productService: null,
  async created() {
    this.productService = new ProductService();
    this.initFilters();
    this.user_key = localStorage.getItem("user_type");
  },
  async mounted() {
    this.id = this.$route.params.id;
    this.lazyParams = {
      first: 0,
      rows: this.limit,
      sortField: null,
      sortOrder: null,
      filters: this.filters,
    };
    if (this.totalRecords == 0) {
      await this.get_count();
    }
    await this.get_list();
  },
  watch: {
    currentLocale() {

    },
    async $route() {
      this.products = [];
      this.columns = [];
      this.totalRecords = 0;
      this.id = this.$route.params.id;
      if (this.id) {
        await this.get_count();
        this.get_list();
      }
    },
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    dateFormatDMY(inputDate) {
      var postdate = inputDate;
      if (inputDate) {
        inputDate = new Date(inputDate);
        if (inputDate.toString() == "NaN-NaN-NaN") {
          return postdate;
        } else {
          let date = ("0" + inputDate.getDate()).slice(-2);
          // current month
          let month = ("0" + (inputDate.getMonth() + 1)).slice(-2);
          // current year
          let year = inputDate.getFullYear();
          if (date.toString() == "aN") {
            return postdate;
          } else {
            return date + "/" + month + "/" + year;
          }
        }
      } else {
        return "";
      }
    },
    async save_event() {
      if (!this.product.job_title) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_title"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.job_title_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_title_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.job_title_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_title_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.experience_required) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_experience_required"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.job_description) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_description"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.job_description_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_description_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.job_description_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_job_description_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.vacancies) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_vacancies"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.qualification) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_qualification"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.qualification_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_qualification_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.qualification_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_qualification_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.posted_date) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_posted_date"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.location) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_location"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.location_mr) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_location_mr"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.location_hi) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_location_hi"),
          life: 3000,
        });
        return false;
      }
      if (!this.product.last_date_to_apply) {
        this.$toast.add({
          severity: "error",
          summary: this.$t("error"),
          detail: this.$t("enter_last_date_to_apply"),
          life: 3000,
        });
        return false;
      }
      
      var details = {};
      if (this.product._id) {
        details = {
          "_id": this.product._id,
          "job_title": this.product.job_title,
          "job_title_mr":this.product.job_title_mr,
          "job_title_hi":this.product.job_title_hi,
          "job_description": this.product.job_description,
          "job_description_mr":  this.product.job_description_mr,
          "job_description_hi": this.product.job_description_hi,
          "qualification": this.product.qualification,
          "qualification_mr": this.product.qualification_mr,
          "qualification_hi":this.product.qualification_hi,
          "experience_required": this.product.experience_required,
          "vacancies": this.product.vacancies,
          "location": this.product.location,
          "location_mr":this.product.location_mr,
          "location_hi": this.product.location_hi,
          "last_date_to_apply": this.product.last_date_to_apply,
          "posted_date": this.product.posted_date,
          "status": this.addeditstatus_dropdownItem?.value,
          "updated_by": localStorage.getItem("id"),
          "lang": this.$i18n.locale,
        };
        var promise = apis.updateJobOpenings(details);
      } else {
        details = {
          "job_title": this.product.job_title,
          "job_title_mr":this.product.job_title_mr,
          "job_title_hi":this.product.job_title_hi,
          "job_description": this.product.job_description,
          "job_description_mr":  this.product.job_description_mr,
          "job_description_hi": this.product.job_description_hi,
          "qualification": this.product.qualification,
          "qualification_mr": this.product.qualification_mr,
          "qualification_hi":this.product.qualification_hi,
          "experience_required": this.product.experience_required,
          "vacancies": this.product.vacancies,
          "location": this.product.location,
          "location_mr":this.product.location_mr,
          "location_hi": this.product.location_hi,
          "last_date_to_apply": this.product.last_date_to_apply,
          "posted_date": this.product.posted_date,
           "status": this.addeditstatus_dropdownItem?.value,
          
          created_by: localStorage.getItem("id"),
          client_id: localStorage.getItem("client_id"),
          lang: this.$i18n.locale,
        };
        var promise = apis.createJobOpenings(details);
      }
      this.isLoadingModel = true;
      promise.then((response) => {
        this.isLoadingModel = false;
        if (response.data.status == true) {
          this.$toast.add({
            severity: "success",
            summary: "success",
            detail: response.data.message,
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "error",
            detail: response.data.message,
            life: 3000,
          });
        }
        this.productDialog = false;
        this.get_list();
        this.get_count();
      });
    },
    async search(count) {
      if (count == 2) {
        this.search_filter = "";
        this.status_dropdownItem = null;
      }
      await this.get_list();
      await this.get_count();
    },
    async onPage(event) {
      this.lazyParams = event;
      this.page_no = event.page + 1;
      this.limit = event.rows;
      // console.log(event);
      //  await this.get_count();
      if (this.totalRecords > 0) {
        this.get_list();
      }
    },
    get_count: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: true,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListJobOpenings(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.totalRecords = response.data.data;
        if (this.totalRecords > 100) {
          this.PerPageOptions.push(this.totalRecords);
        }
        //alert(this.totalRecords);
      });
      console.log(data);
    },
    get_list: function () {
      var data = {
        client_id: localStorage.getItem("client_id"),
        status: this.status_dropdownItem?.value,
        search: this.search_filter,
        count: false,
        page_no: this.page_no,
        limit: this.limit,
        //AsOnDate: "",
      };
      this.loading = true;
      var promise = apis.ListJobOpenings(data, this.id);
      promise.then((response) => {
        this.loading = false;
        console.log(response);
        this.products = response.data.data;
        console.log(this.products[0]);
        if (this.columns.length == 0) {
          if (this.products.length > 0) {
            this.columns = Object.keys(this.products[0]);
          }
        }
      });
      console.log(data);
    },
    openNew() {
      this.product = {};
      this.submitted = false;
      this.productDialog = true;
      this.addeditstatus_dropdownItem = { name: "Active", value: "Active" };
    },
    async viewProduct(product)
    {
      this.product = { ...product };
      localStorage.setItem("product", JSON.stringify(this.product));
      this.$router.push({ name: "JobApplication"});
    },
    async editProduct(product) {
      this.file_attachment = "";
      this.product = { ...product };
      this.addeditstatus_dropdownItem = null;
      if (this.product.status) 
      {
        this.addeditstatus_dropdownItem = {
          name: this.product.status,
          value: this.product.status,
        };
      }
      if (this.product.last_date_to_apply) {
        this.product.last_date_to_apply = new Date(this.product.last_date_to_apply);
      }
      if (this.product.posted_date) {
        this.product.posted_date = new Date(this.product.posted_date);
      }
      this.productDialog = true;
    },
    confirmDeleteProduct(product) {
      this.product = product;
      this.deleteProductDialog = true;
    },
    deleteevent() {
      if (this.product._id) {
        var data = {
          "_id": this.product._id,
          "job_title": this.product.job_title,
          "job_title_mr":this.product.job_title_mr,
          "job_title_hi":this.product.job_title_hi,
          "job_description": this.product.job_description,
          "job_description_mr":  this.product.job_description_mr,
          "job_description_hi": this.product.job_description_hi,
          "qualification": this.product.qualification,
          "qualification_mr": this.product.qualification_mr,
          "qualification_hi":this.product.qualification_hi,
          "experience_required": this.product.experience_required,
          "vacancies": this.product.vacancies,
          "location": this.product.location,
          "location_mr":this.product.location_mr,
          "location_hi": this.product.location_hi,
          "last_date_to_apply": this.product.last_date_to_apply,
          "posted_date": this.product.posted_date,
          "status": "Deleted",
          "updated_by": localStorage.getItem("id"),
          "lang": this.$i18n.locale,
        };
        this.isLoadingModel = true;
        var promise = apis.updateJobOpenings(data);
        promise.then((responseapi) => {
          this.isLoadingModel = false;
          if (responseapi.data.status == true) {
            this.$toast.add({
              severity: "success", // success, info, warn, error
              summary: this.$t("success"),
              detail: responseapi.data.message,
              life: 3000, // Toast disappears after 3 seconds
            });
            this.deleteProductDialog = false;
            this.get_list();
            this.get_count();
          } else {
            this.$swal("error to Delete Asset Type");
          }
        });
      }
    },
    async exportCSV() {
      this.limit = this.totalRecords;
      this.get_list();
      await this.$refs.dt.exportCSV();
    },
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    },
  },
  components: {},
};
</script>
  <style scoped lang="scss">
@import "../assets/demo/badges.scss";
</style>
  